import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {AdList} from "../../interfaces/ad";
import {CursorToken} from "../../interfaces/utils";
import {ApiService} from "../../services/api.service";
import { KazButtonComponent } from '../kaz-button/kaz-button.component';
import { RouterLink } from '@angular/router';
import { KazCardArchiveAdsComponent } from '../kaz-card-archive-ads/kaz-card-archive-ads.component';

@Component({
    selector: 'kaz-archive',
    templateUrl: './kaz-archive.component.html',
    styleUrls: ['./kaz-archive.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [KazButtonComponent, RouterLink, KazCardArchiveAdsComponent]
})

export class KazArchiveComponent implements OnInit {
  private _api = inject(ApiService);

  ownAds: AdList | null = null;

  nextToken: CursorToken = "@start";

  async ngOnInit() {
    await this.getArchivedAds()
  }

  async getArchivedAds() {
    try {
      this.ownAds = await this._api.getArchivedAdList(this.nextToken, 24);
    } catch (err) {

    }
  }

  refreshArchivedAds(){
    this.getArchivedAds().then();
  }
}
